import { render } from "./Suggestion.vue?vue&type=template&id=c7481dde&scoped=true"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"

import "./Suggestion.vue?vue&type=style&index=0&id=c7481dde&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7481dde"]])

export default __exports__